import React, { useState } from 'react';
import { db } from './firebaseconfig';
import './Style/addsaloon.css';
import { doc, setDoc, getDoc } from 'firebase/firestore';

const Fetchsalon = () => {
  // Include the commission percentage and Maxdiscount in the initial state.
  const initialSalonDetails = {
    name: '',
    type: '',
    address: '',
    latitude: '',
    longitude: '',
    openingHours: '',
    closingHours: '',
    phoneNumber: '',
    barberEmail: '',
    about: '',
    percentage: '',
    Maxdiscount: '',
  };

  const [salonDetails, setSalonDetails] = useState(initialSalonDetails);
  const [saloonId, setSaloonId] = useState('');
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  // Service-related state variables
  const [serviceTitle, setServiceTitle] = useState('');
  const [serviceName, setServiceName] = useState('');
  const [servicePrice, setServicePrice] = useState('');
  const [serviceQuantity, setServiceQuantity] = useState('');
  const [serviceTime, setServiceTime] = useState('');
  const [serviceGender, setServiceGender] = useState('');
  // New state variables for service percentages
  const [servicePercentage1, setServicePercentage1] = useState('');
  
  const [services, setServices] = useState([]);
  const [isAddingServices, setIsAddingServices] = useState(false);
  const [serviceIdCounter, setServiceIdCounter] = useState(1);
  // This state holds the editing mode information (if a service detail is being edited)
  const [editingService, setEditingService] = useState(null); // { categoryIndex, subIndex, gender } or null

  const [isLoading, setIsLoading] = useState(false);

  // Fetch salon data (including Maxdiscount and services with percentages) by Salon ID
  const fetchSalonData = async () => {
    if (!saloonId) {
      alert('Please enter a salon ID.');
      return;
    }
    try {
      const docRef = doc(db, 'saloons', saloonId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setSalonDetails({
          name: data.name || '',
          type: data.type || '',
          address: data.address || '',
          latitude: data.latitude || '',
          longitude: data.longitude || '',
          openingHours: data.openingHours || '',
          closingHours: data.closingHours || '',
          phoneNumber: data.phoneNumber || '',
          barberEmail: data.barberEmail || '',
          about: data.about || '',
          percentage: data.percentage || '',
          Maxdiscount: data.Maxdiscount || '',
        });
        setServices(data.services || []);
        setIsDataLoaded(true);
      } else {
        alert('Salon not found!');
        setIsDataLoaded(false);
      }
    } catch (error) {
      console.error('Error fetching salon data: ', error);
      alert('Error fetching salon data.');
    }
  };

  // Handle changes for salon detail inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSalonDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // Add new service detail or update an existing one if in editing mode
  const handleAddOrUpdateService = () => {
    const newService = {
      id: editingService
        ? services[editingService.categoryIndex][
            editingService.gender ? editingService.gender : 'services'
          ][editingService.subIndex].id
        : serviceIdCounter,
      name: serviceName || null,
      price: servicePrice ? parseFloat(servicePrice) : null,
      quantity: serviceQuantity ? parseInt(serviceQuantity) : null,
      time: serviceTime || null,
      // New percentage fields in each service detail
      percentage: servicePercentage1 || null,
      
    };

    if (editingService) {
      // Update existing service detail
      const updatedServices = [...services];
      if (salonDetails.type === 'unisex' && editingService.gender) {
        updatedServices[editingService.categoryIndex][editingService.gender][editingService.subIndex] = newService;
      } else {
        updatedServices[editingService.categoryIndex].services[editingService.subIndex] = newService;
      }
      setServices(updatedServices);
      setEditingService(null);
    } else {
      // Add new service detail
      const categoryIndex = services.findIndex((service) => service.title === serviceTitle);
      if (categoryIndex !== -1) {
        const updatedServices = [...services];
        if (salonDetails.type === 'unisex') {
          updatedServices[categoryIndex][serviceGender] = [
            ...(updatedServices[categoryIndex][serviceGender] || []),
            newService,
          ];
        } else {
          updatedServices[categoryIndex].services = [
            ...(updatedServices[categoryIndex].services || []),
            newService,
          ];
        }
        setServices(updatedServices);
      } else {
        // Create a new service category
        if (salonDetails.type === 'unisex') {
          setServices([
            ...services,
            {
              title: serviceTitle || null,
              male: serviceGender === 'male' ? [newService] : [],
              female: serviceGender === 'female' ? [newService] : [],
            },
          ]);
        } else {
          setServices([
            ...services,
            {
              title: serviceTitle || null,
              services: [newService],
            },
          ]);
        }
      }
      setServiceIdCounter((prevCounter) => prevCounter + 1);
    }

    // Clear service fields
    setServiceTitle('');
    setServiceName('');
    setServicePrice('');
    setServiceQuantity('');
    setServiceTime('');
    setServiceGender('');
    setServicePercentage1('');
    
    setIsAddingServices(false);
  };

  const handleAddServiceDetail = () => {
    if (!serviceTitle) {
      alert('Please enter a service title.');
      return;
    }
    setIsAddingServices(true);
  };

  // Load a specific service detail for editing
  const handleEditService = (categoryIndex, subIndex, gender = null) => {
    let serviceDetail;
    if (salonDetails.type === 'unisex' && gender) {
      serviceDetail = services[categoryIndex][gender][subIndex];
      setServiceGender(gender);
    } else {
      serviceDetail = services[categoryIndex].services[subIndex];
    }
    // Set the category title in the input so that it can be edited if needed.
    setServiceTitle(services[categoryIndex].title);
    setServiceName(serviceDetail.name);
    setServicePrice(serviceDetail.price);
    setServiceQuantity(serviceDetail.quantity);
    setServiceTime(serviceDetail.time);
    setServicePercentage1(serviceDetail.percentage || '');
    
    setEditingService({ categoryIndex, subIndex, gender });
    setIsAddingServices(true);
  };

  const handleCancelEditService = () => {
    setEditingService(null);
    setServiceTitle('');
    setServiceName('');
    setServicePrice('');
    setServiceQuantity('');
    setServiceTime('');
    setServiceGender('');
    setServicePercentage1('');
    
    setIsAddingServices(false);
  };

  // Submit updated salon data (merging changes) and then clear all fields.
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!saloonId) {
      alert('Please enter a salon ID.');
      return;
    }
    setIsLoading(true);
    try {
      const updatedSalonData = {
        ...Object.fromEntries(
          Object.entries(salonDetails).filter(([_, v]) => v !== undefined && v !== '')
        ),
        services: services.map((service) => ({
          title: service.title || null,
          male: service.male || [],
          female: service.female || [],
          services: service.services || [],
        })),
      };
      console.log('Updating data:', updatedSalonData);
      await setDoc(doc(db, 'saloons', saloonId), updatedSalonData, { merge: true });
      alert('Salon updated successfully!');

      // Clear all fields after update
      setSalonDetails(initialSalonDetails);
      setSaloonId('');
      setServices([]);
      setServiceTitle('');
      setServiceName('');
      setServicePrice('');
      setServiceQuantity('');
      setServiceTime('');
      setServiceGender('');
      setServicePercentage1('');
    
      setEditingService(null);
      setIsDataLoaded(false);
    } catch (error) {
      console.error('Error updating salon data: ', error);
      alert('Error updating salon data.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      {/* Left Panel: Editable Form */}
      <div className="form-container">
        <h1>{isDataLoaded ? 'Edit Salon' : 'Add New Salon'}</h1>
        <div className="salon-id-section">
          <input
            type="text"
            name="saloonId"
            placeholder="Salon ID"
            value={saloonId}
            onChange={(e) => setSaloonId(e.target.value)}
            required
          />
          <button type="button" onClick={fetchSalonData}>
            Load Salon Data
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Salon Name"
            value={salonDetails.name}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="type"
            placeholder="Salon Type (male, female, unisex)"
            value={salonDetails.type}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={salonDetails.address}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="latitude"
            placeholder="Latitude"
            value={salonDetails.latitude}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="longitude"
            placeholder="Longitude"
            value={salonDetails.longitude}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="openingHours"
            placeholder="Opening Hours"
            value={salonDetails.openingHours}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="closingHours"
            placeholder="Closing Hours"
            value={salonDetails.closingHours}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="phoneNumber"
            placeholder="Phone Number"
            value={salonDetails.phoneNumber}
            onChange={handleInputChange}
            required
          />
          <input
            type="email"
            name="barberEmail"
            placeholder="Barber's Email"
            value={salonDetails.barberEmail}
            onChange={handleInputChange}
            required
          />
          <textarea
            name="about"
            placeholder="About the Salon"
            value={salonDetails.about}
            onChange={handleInputChange}
          />
          <input
            type="number"
            name="percentage"
            placeholder="Commission Percentage"
            value={salonDetails.percentage}
            onChange={handleInputChange}
            required
          />
          <input
            type="number"
            name="Maxdiscount"
            placeholder="Max Discount"
            value={salonDetails.Maxdiscount}
            onChange={handleInputChange}
            required
          />

          <h2>{editingService ? 'Edit Service' : 'Add Service'}</h2>
          {!isAddingServices ? (
            <>
              <input
                type="text"
                placeholder="Service Title (Category)"
                value={serviceTitle}
                onChange={(e) => setServiceTitle(e.target.value)}
              />
              {salonDetails.type === 'unisex' && (
                <select
                  value={serviceGender}
                  onChange={(e) => setServiceGender(e.target.value)}
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              )}
              <button type="button" onClick={handleAddServiceDetail}>
                Add Service Details
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                placeholder="Service Name"
                value={serviceName}
                onChange={(e) => setServiceName(e.target.value)}
                required
              />
              <input
                type="number"
                placeholder="Quantity"
                value={serviceQuantity}
                onChange={(e) => setServiceQuantity(e.target.value)}
                required
              />
              <input
                type="number"
                placeholder="Price"
                value={servicePrice}
                onChange={(e) => setServicePrice(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Time"
                value={serviceTime}
                onChange={(e) => setServiceTime(e.target.value)}
                required
              />
              {/* New fields for service percentages */}
              <input
                type="text"
                placeholder="Service Percentage 1"
                value={servicePercentage1}
                onChange={(e) => setServicePercentage1(e.target.value)}
                required
              />
              
              <div className="service-button-group">
                <button type="button" onClick={handleAddOrUpdateService}>
                  {editingService ? 'Update Service' : 'Add Service'}
                </button>
                {editingService && (
                  <button type="button" onClick={handleCancelEditService}>
                    Cancel
                  </button>
                )}
              </div>
            </>
          )}
          <button type="submit" className="submit-button" disabled={isLoading}>
            {isLoading ? 'Updating...' : 'Update Salon'}
          </button>
        </form>
      </div>

      {/* Right Panel: Review Summary */}
      <div className="summary-container">
        <h2>Review Details</h2>
        <p>
          <strong>Salon ID:</strong> {saloonId}
        </p>
        <p>
          <strong>Name:</strong> {salonDetails.name}
        </p>
        <p>
          <strong>Type:</strong> {salonDetails.type}
        </p>
        <p>
          <strong>Address:</strong> {salonDetails.address}
        </p>
        <p>
          <strong>Latitude:</strong> {salonDetails.latitude}
        </p>
        <p>
          <strong>Longitude:</strong> {salonDetails.longitude}
        </p>
        <p>
          <strong>Opening Hours:</strong> {salonDetails.openingHours}
        </p>
        <p>
          <strong>Closing Hours:</strong> {salonDetails.closingHours}
        </p>
        <p>
          <strong>Phone Number:</strong> {salonDetails.phoneNumber}
        </p>
        <p>
          <strong>Barber's Email:</strong> {salonDetails.barberEmail}
        </p>
        <p>
          <strong>About:</strong> {salonDetails.about}
        </p>
        <p>
          <strong>Commission Percentage:</strong> {salonDetails.percentage}
        </p>
        <p>
          <strong>Max Discount:</strong> {salonDetails.Maxdiscount}
        </p>
        {services.length > 0 && (
          <div>
            <h3>Services</h3>
            {services.map((service, catIndex) => (
              <div key={catIndex} className="service-category">
                <p>
                  <strong>Category:</strong> {service.title}
                </p>
                {salonDetails.type === 'unisex' ? (
                  <>
                    <p>
                      <strong>Male Services:</strong>
                    </p>
                    {service.male &&
                      service.male.map((svc, subIndex) => (
                        <div key={subIndex} className="service-detail">
                          <p>
                            Name: {svc.name}, Price: {svc.price}, Quantity: {svc.quantity}, Time: {svc.time}
                            {svc.percentage1 && `, Percentage1: ${svc.percentage1}`}
                            {svc.percentage2 && `, Percentage2: ${svc.percentage2}`}
                            <button
                              type="button"
                              onClick={() => handleEditService(catIndex, subIndex, 'male')}
                            >
                              Edit
                            </button>
                          </p>
                        </div>
                      ))}
                    <p>
                      <strong>Female Services:</strong>
                    </p>
                    {service.female &&
                      service.female.map((svc, subIndex) => (
                        <div key={subIndex} className="service-detail">
                          <p>
                            Name: {svc.name}, Price: {svc.price}, Quantity: {svc.quantity}, Time: {svc.time}
                            {svc.percentage1 && `, Percentage1: ${svc.percentage1}`}
                            {svc.percentage2 && `, Percentage2: ${svc.percentage2}`}
                            <button
                              type="button"
                              onClick={() => handleEditService(catIndex, subIndex, 'female')}
                            >
                              Edit
                            </button>
                          </p>
                        </div>
                      ))}
                  </>
                ) : (
                  <>
                    {service.services &&
                      service.services.map((svc, subIndex) => (
                        <div key={subIndex} className="service-detail">
                          <p>
                            Name: {svc.name}, Price: {svc.price}, Quantity: {svc.quantity}, Time: {svc.time}
                            {svc.percentage1 && `, Percentage1: ${svc.percentage1}`}
                            {svc.percentage2 && `, Percentage2: ${svc.percentage2}`}
                            <button
                              type="button"
                              onClick={() => handleEditService(catIndex, subIndex)}
                            >
                              Edit
                            </button>
                          </p>
                        </div>
                      ))}
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Fetchsalon;
